import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(165, 42, 42)',
    },
    secondary: {
      main: 'rgb(145, 56, 49)',
    },
  },
});
